<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M19 2C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5C2 3.34315 3.34315 2 5 2H19ZM4 19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V14H16.9C16.4512 16.2109 14.5435 17.8921 12.2256 17.995L12 18C9.65663 18 7.68979 16.3879 7.14797 14.2123L7.10002 14H4V19ZM19 4H5C4.44772 4 4 4.44772 4 5V12H8C8.51284 12 8.93551 12.386 8.99327 12.8834L9 13C9 14.6569 10.3431 16 12 16C13.5977 16 14.9037 14.7511 14.9949 13.1763L15.0067 12.8834C15.0601 12.4243 15.4243 12.0601 15.8834 12.0067L16 12H20V5C20 4.44772 19.5523 4 19 4Z"
    fill="currentColor"
  />
</svg>
